<div class="header-container">
  <div class="logo-container">
    <a (click)="toggleSidebar()" href="#" class="sidebar-toggle">
      <nb-icon icon="menu-2-outline"></nb-icon>
    </a>
    <img src="assets/images/efs-logo.svg" (click)="navigateHome()" alt="EFS Logo" class="logo logo-default" style="height: 30px;">
    <img src="assets/images/efs-logo-white.svg" (click)="navigateHome()" alt="EFS Logo" class="logo logo-dark" style="height: 30px;">
    <a href="#" class="d-none d-md-block logo" (click)="navigateHome()">EFS Admin</a>
  </div>
</div>

<div class="header-container">
  <nb-actions size="small">
    <nb-action nbTooltip="Diese Information dient ausschließlich zu Informationszwecken, die Session wird automatisch erneuert." nbTooltipPlacement="bottom" *ngIf="userData" class="user-action action-link" (click)="checkExpiryAndRefresh(true)">
      Aktuelle Session-Gültigkeit: {{ nbfTimeStamp }} Uhr bis {{ expiryTimeStamp }} Uhr
    </nb-action>
    <nb-action *ngIf="userData" (click)="copyToken()" class="user-action action-link">
      {{ userData.name }}
    </nb-action>
    <nb-action (click)="logout()" class="action-link">
      <nb-icon icon="lock-outline"></nb-icon>
    </nb-action>
  </nb-actions>
</div>